define.alias("shared/components/shared/social/instagram-upgrade/banner", "settings/components/shared/social/instagram-upgrade/banner");